import './index.css'
import cn from 'clsx'
import * as React from 'react'
import Checkbox from 'components/ui/checkbox'
export type Props = {
  caption?: string
  className?: string
  formats?: string[]
  selectedFormats: (string | null | undefined)[]
  onFormatClick: (...args: Array<any>) => any
}

/**
 * SelectableTrackFormats component for displaying selectable audio format options
 *
 * A functional component that renders a list of checkboxes for different audio formats
 * that users can select or deselect. Supports optional caption display and handles
 * empty format entries with spacing elements.
 *
 * @param props - Component props
 * @param props.caption - Optional caption text to display above format options
 * @param props.className - Additional CSS class names
 * @param props.formats - Array of available format strings
 * @param props.selectedFormats - Array of currently selected format strings
 * @param props.onFormatClick - Callback function called when a format is clicked
 * @returns JSX element containing the selectable format checkboxes
 */
const SelectableTrackFormats = (props: Props): React.ReactElement<'div'> => {
  const { caption, className, formats, selectedFormats, onFormatClick } = props
  const checkboxes = (formats || []).map((fmt, idx) =>
    fmt ? (
      <Checkbox
        key={fmt}
        className="selectable-track-formats__checkbox"
        label={fmt.toUpperCase()}
        checked={selectedFormats.includes(fmt)}
        onChange={() => onFormatClick(fmt)}
      />
    ) : (
      <span
        key={`whitespace-${idx}`}
        className="selectable-track-formats__checkbox"
      />
    ),
  )
  return (
    <div className={cn('selectable-track-formats', className)}>
      {caption && (
        <div className="selectable-track-formats__caption">{caption}</div>
      )}
      {checkboxes}
    </div>
  )
}

export default SelectableTrackFormats
